
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 39.5C9.2 39.5.5 30.8.5 20S9.2.5 20 .5 39.5 9.2 39.5 20 30.8 39.5 20 39.5zm0-37.4c-9.9 0-17.9 8-17.9 17.9 0 9.9 8 17.9 17.9 17.9 9.9 0 17.9-8 17.9-17.9 0-9.9-8-17.9-17.9-17.9z"}}),_c('path',{attrs:{"d":"M28.1 20.8H11.9c-.4 0-.8-.4-.8-.8s.4-.8.8-.8H28c.4 0 .8.4.8.8s-.3.8-.7.8z"}})])
          )
        }
      }
    